import { useContext } from 'react';

import { ShellContext, type ShellContextValue } from './shell-context.js';

export function useShell(): ShellContextValue {
  const ctx = useContext(ShellContext);
  if (ctx === null) {
    throw new Error('useShell must be used within a ShellProvider');
  }
  return ctx;
}
